const getAuthToken = () => {
  return localStorage.getItem("token");
};

// intercepts requests to add Authorization token
const authInterceptor = config => {
  config.headers["Authorization"] = getAuthToken() || "";
  config.headers["Content-Type"] = "application/json";
  return config;
};

export default authInterceptor;
